<template>
  <div class='shopbot'>
    <Timeline
      :cnc="cnc"
      @change='(t) => { $emit("change", t); }'
      @binvisible='(e) => { $emit("binvisible", e); }'
      @toolpathvisible='(e) => { $emit("toolpathvisible", e); }'
      @cncvisible='(e) => { $emit("cncvisible", e); }'
      @labelinfovisible='(e) => { $emit("labelinfovisible", e); }'
    />
    <div class='download-button-wrapper'>
      <!-- <a class="button" @click='$emit("calculate")'>
        <img src='@/assets/images/ui/download-sbp-black.png' /><span>自動見積り</span>
      </a> -->
      <a class='button' @click.prevent.stop='downloadSBP'>
        <img src='@/assets/images/ui/download-sbp-black.png' /><span>{{ $t('SBPダウンロード') }}</span>
      </a>
      <a v-show='isDownloadableDXF()' class='button download-dxf-button' @click.prevent.stop='downloadDXF'>
        <img src='@/assets/images/ui/download-sbp-black.png' /><span>{{ $t('DXFダウンロード') }}</span>
      </a>
    </div>
  </div>
</template>

<script>
import Timeline from '../Timeline.vue';
import { converter } from '../../assets/javascripts/dxf/DxfConverter';

export default {
  name: 'ShopbotMenu',
  components: {
    Timeline
  },
  props: {
    cnc: {
      type: Boolean,
      required: true
    },
    sbp: {
      type: Object,
      default: null
    },
    exportComponents: {
      type: Array,
      default: () => { return []; }
    }
  },
  methods: {
    isDownloadableDXF () {
      return this.exportComponents.length > 0 && this.exportComponents.some((component) => component.paths !== undefined);
    },
    downloadSBP () {
      if (this.sbp !== null) {
        this.sbp.download();
      }
    },
    downloadDXF () {
      const dxf = converter(this.exportComponents);
      const url = URL.createObjectURL(new Blob([dxf], { type: 'text/dxf' }));
      const link = document.createElement('a');
      link.href = url;
      if (this.sbp !== null) {
        link.setAttribute('download', `${this.sbp.name}.dxf`);
      } else {
        link.setAttribute('download', 'emarf.dxf');
      }
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
};

</script>



// WEBPACK FOOTER //
// src/components/viewer/ShopbotMenu.vue